export function eventScroll() {
    $(".rooms .button").click(function () {
        $([document.documentElement, document.body]).animate({
                scrollTop: $("#event-contact-form").offset().top - 220
            },
            2000
        );
        return false;
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/event-scroll.js